import { render, staticRenderFns } from "./AppBooleanAnswer.vue?vue&type=template&id=65eba1b4&scoped=true"
import script from "./AppBooleanAnswer.vue?vue&type=script&lang=ts"
export * from "./AppBooleanAnswer.vue?vue&type=script&lang=ts"
import style0 from "./AppBooleanAnswer.vue?vue&type=style&index=0&id=65eba1b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65eba1b4",
  null
  
)

export default component.exports